export const API_URL = '/sellers/external';
export default API_URL;
